import { Permission } from '@dispatch/shared/types';
import { Checkbox } from '@mui/material';
import React, { useEffect } from 'react';
import { UseFormSetValue } from 'react-hook-form';

interface ControlledCheckBoxProps {
  setValue: UseFormSetValue<{
    name: string;
    permissions: string[];
  }>;
  permission: Permission;
  formPermissions: string[];
  disabled?: boolean;
}

export const PermissionCheckBox = ({
  setValue,
  permission,
  formPermissions,
  disabled,
}: ControlledCheckBoxProps) => {
  const [checked, setChecked] = React.useState(false);

  useEffect(() => {
    if (formPermissions.includes(permission.id)) {
      setChecked(true);
    }
  }, [formPermissions.length]);

  return (
    <Checkbox
      data-testid="permisison-checkbox"
      onChange={(e) => {
        const { value, checked: currentValue } = e.target;
        const currentFormPermissions = formPermissions;

        if (currentValue) {
          setChecked(true);
          currentFormPermissions.push(value);
          setValue('permissions', currentFormPermissions, {
            shouldDirty: true,
          });
        } else {
          setChecked(false);
          const index = currentFormPermissions.indexOf(value);
          if (index >= 0) {
            currentFormPermissions.splice(index, 1);
            setValue('permissions', currentFormPermissions, {
              shouldDirty: true,
            });
          }
        }
      }}
      value={`${permission?.id}`}
      checked={checked}
      disabled={disabled || false}
    />
  );
};
